/**
 * /admin/ai-usage - the route.
 *
 * It owns the URL search contract and nothing else; the page lives in
 * components/admin/ai-usage. The admin layout's nav entry for this path carries
 * no `support` flag, so a support_admin gets Access Restricted here - and the
 * `admin_ai_usage` RPC raises 42501 for the same role, so the gate holds even on
 * a hand-typed URL.
 */
import { createFileRoute } from '@tanstack/react-router';
import { AiUsagePage } from '@/components/admin/ai-usage/AiUsagePage';
import { parseAiUsageSearch, type AiUsageSearch } from '@/lib/admin/ai-usage-window';

export const Route = createFileRoute('/admin/ai-usage')({
  component: AiUsagePage,
  validateSearch: (search: Record<string, unknown>): AiUsageSearch =>
    parseAiUsageSearch(search),
});

// NOTE: nothing else may be exported from a route file. The TanStack
// code-splitting plugin rewrites `component` into a lazy import and drops the
// import it came from, so a re-export here compiles to an undefined binding.
